import LoginPage from './login';
import LoginForm from './form';

export { LoginForm };
export default LoginPage;